<template>
  <router-view name="default" />
</template>
<script>
import '@/assets/css/form_settings.css'
export default {

}
</script>